import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { TemplateItemDataFragment } from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { TemplateListItem } from './template-list-item';

type TemplateListProps = {
  loading?: boolean;
  items: TemplateItemDataFragment[];
  onClick?: (value: TemplateItemDataFragment) => void;
};

export function TemplateList({
  loading = false,
  onClick,
  ...props
}: TemplateListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.id} className="content-list__item">
          <TemplateListItem template={option} onClick={onClick} />
        </div>
      ))}
    </div>
  );
}
